import { WebsiteFitEvidence } from '../types/results.types';

export interface DeduplicatedProof {
  snippet: string;
  pageUrl: string;
  pageDomain: string;
  tags: string[];
  matchedTerms: string[];
}

function trimToWholeWords(text: string, maxLen: number): string {
  const clean = text.replace(/\s+/g, ' ').trim();
  if (clean.length <= maxLen) return clean;
  const truncated = clean.slice(0, maxLen);
  const lastSpace = truncated.lastIndexOf(' ');
  return (lastSpace > 0 ? truncated.slice(0, lastSpace) : truncated) + '…';
}

function extractDomain(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

export function deduplicateProof(evidence: WebsiteFitEvidence[]): DeduplicatedProof[] {
  const seen = new Map<string, DeduplicatedProof>();

  for (const item of evidence) {
    const normalizedSnippet = item.snippet.replace(/\s+/g, ' ').trim().toLowerCase();
    const key = normalizedSnippet;

    const existing = seen.get(key);
    if (existing) {
      if (!existing.tags.includes(item.tag)) {
        existing.tags.push(item.tag);
      }
      if (!existing.matchedTerms.includes(item.matched_term)) {
        existing.matchedTerms.push(item.matched_term);
      }
    } else {
      seen.set(key, {
        snippet: trimToWholeWords(item.snippet, 160),
        pageUrl: item.page_url,
        pageDomain: extractDomain(item.page_url),
        tags: [item.tag],
        matchedTerms: [item.matched_term],
      });
    }
  }

  return Array.from(seen.values());
}

export function groupProofByTag(
  evidence: WebsiteFitEvidence[],
  matchedOfferings: string[],
  maxPerTag = 2,
): Map<string, DeduplicatedProof[]> {
  const all = deduplicateProof(evidence);
  const byTag = new Map<string, DeduplicatedProof[]>(matchedOfferings.map(o => [o, []]));

  for (const proof of all) {
    for (const tag of proof.tags) {
      const list = byTag.get(tag);
      if (list && list.length < maxPerTag) {
        list.push(proof);
      }
    }
  }

  return byTag;
}
